/**
 * Workspace memory graph: GET memory/graph returns {nodes, edges, stats}.
 *   no conversation_id   the whole workspace (conversations, entities, remembered facts)
 *   conversation_id      one conversation (turns in order, the entities and pages each turn used)
 */
import axios from 'axios';
import { apiUrl } from './config';

const userEmail = () => (typeof localStorage !== 'undefined' ? localStorage.getItem('userinfo') : null);

export async function fetchMemoryGraph(conversationId) {
  const params = { userEmail: userEmail() };
  if (conversationId) params.conversation_id = conversationId;
  const res = await axios.get(apiUrl('memory/graph'), { params });
  return res.data;
}
